import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getDevice } from '../../../reducers';
import Button from '../Button/Button';
import { getIsUserLoggedIn } from '../../../utils/cookie';
import { setOrderGrooveFrequency, setUpdateCartForOrderGroove } from '../../../utils/subscriptions';
import initAddToCart from './initAddToCart';
import { formatBuyAgainFulfillmentMethod } from '../../../utils/format';
import { setAddToCartEventInfo } from '../../../analytics/gatherService';
import SubscribeAndSaveToolTip from '../SubscribeAndSave/SubscribeAndSaveToolTip';
import Checkbox from '../Checkbox/Checkbox';

type Props = {
  history: Object,
  isMobile: boolean,
  fulfillmentLocation: string,
  fulfillmentMethod: string,
  omsId: number,
  quantity: number,
  subscriptionDefaultFrequency: string,
  isEReceipt?: boolean,
  isInstore?: boolean
};

class AddToCart extends Component<Props> {

  static createSubscriptionLabel () {
    return (
      <span className="u__bold subscribe-and-save-label">
         SUBSCRIBE AND <span className="body__color--orange"> GET 5% OFF</span>
      </span>
    );
  };

  constructor() {
    super();
    this.state = {
      subscriptionChecked:false
    };
  }

  handleCheckboxChange = () => {
    const { state } = this;
    const { subscriptionChecked } = state;
    this.setState({subscriptionChecked: !subscriptionChecked});
  };

  handleClick = () => {
    const {
      history = {},
      isMobile,
      fulfillmentLocation,
      fulfillmentMethod,
      omsId,
      quantity,
      isInstore,
      isEReceipt,
      subscriptionDefaultFrequency
    } = this.props;

    const { state } = this;
    const { subscriptionChecked } = state;
    
    const atcRequest = {
        itemId: omsId.toString(),
        quantity
      };
    if(fulfillmentLocation) atcRequest.fulfillmentLocation = fulfillmentLocation;
    if(fulfillmentMethod) atcRequest.fulfillmentMethod = formatBuyAgainFulfillmentMethod(fulfillmentMethod);
    if(subscriptionChecked){
      setOrderGrooveFrequency(omsId.toString(), subscriptionDefaultFrequency);
      atcRequest.subscriptions = {
        frequency: subscriptionDefaultFrequency,
        ogModule: "pdp_nocontent"
      }
      setUpdateCartForOrderGroove(atcRequest);
    }
    const { pathname } = history.location || { location: {} };
    const isCancelPage = /cancel/.test(pathname);
    /* eslint-disable no-nested-ternary */
    const sharedSection = subscriptionChecked? 'subscription'
      : isCancelPage
      ? 'cancelled order'
      : isInstore
        ? 'in-store order'
        : isEReceipt
          ? "in-store ereceipts"
          : getIsUserLoggedIn()
            ? 'authenticated order'
            : 'guest order';
    /* eslint-enable no-nested-ternary */
    setAddToCartEventInfo(atcRequest.itemId, sharedSection);
    initAddToCart(isMobile, atcRequest);
  };

  render() {
    const {state, props} = this;
    const { dataId, isButton, isSubscriptionEligible, isInstore, isEReceipt, omsId} = props;
    const { subscriptionChecked } = state;
    const randomId = isSubscriptionEligible && `subId${Math.floor(1 + (Math.random() * (100 - 1)))}`;

    // Buy Again is a Button on the Order Details Page and a Link on the Cancel Success Page.
    return <div>
        {isSubscriptionEligible && !isEReceipt && !isInstore &&(
          <div className="col__10-10 col__10-10--xs u--paddingNone-horizontal">
            <Checkbox
              label={AddToCart.createSubscriptionLabel()}
              subscriptionLabel = "true"
              onClickCheckbox={this.handleCheckboxChange}
              isSelected={subscriptionChecked}
              dataId = {dataId}
              id={randomId}
            />
            <div className="u--paddingXlarge-left">
              Delivered for free when you need it most. Pause, skip or cancel at any time.
              <span className="link__separator"> <SubscribeAndSaveToolTip dataId={dataId}/> </span>
            </div>
            <div className="og-offer" data-og-module="pdp_nocontent" data-og-product={omsId.toString()}/>
          </div>
        )}
        <div className="col__10-10 col__4-10--xs u--paddingNone u--paddingSmall-bottom u--paddingXsmall-top">
          {isButton ? (
            <Button
              outline = {!subscriptionChecked}
              outlineDark = {!subscriptionChecked}
              content={subscriptionChecked ? "Subscribe": "Buy Again"}
              onClick={this.handleClick}
              dataId={dataId && dataId}
            />
            ) : (
              <span
                aria-hidden
                role="button"
                className="u__default-link"
                onClick={this.handleClick}
                data-automation-id={dataId && dataId}
              >
                Buy Again
              </span>
          )}
        </div>
    </div>
  }
}

const mapStateToProps = (state: Object) => ({
  isMobile: getDevice(state, 'mobile')
});

AddToCart.defaultProps = {
  configurationId: null,
  dataId: null,
  isButton: true,
  isInstore: false,
  isEReceipt: false
};

export default withRouter(connect(mapStateToProps)(AddToCart));
